<template>
  <section class="section">
    <div class="page">
        <slot/>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SectionPage'
})
</script>
